const phosphateData = {
  hero: 'https://res.cloudinary.com/benchmarkminerals/image/upload/v1732133790/assets/data-reports/price-assessments/benchmarkminerals_Graphs_and_charts_photorealistic_realistic_sh_5ec62e31-e9e0-449b-aee6-4884a93d0b9f_lrcl0h.png',
  forecastBrochureFile: {
    EnvKey: 'forecastBrochurePhosphateFilePdfID',
    file_name: 'Phosphate Forecast Brochure.pdf',
    category: 'public-documents',
  },
  banner: {
    title:
      'Benchmark’s Phosphoric Acid Market Outlook service provides a detailed assessment of supply, demand and prices and is updated on a quarterly basis:',
    descriptions: [
      {
        items: [
          '<strong>Asset-level insights:</strong> Supply analysis broken down by asset with results presented to show market dynamics.',
          '<strong>Plant by Plant:</strong> Granular review of processed materials by operation outside of China, including material flows to processing facilities within China.',
          '<strong>Demand Analysis:</strong> Phosphoric acid demand from lithium-ion batteries by category and regional end-use sector, including assessment of short-term market movements.',
          '<strong>Price Forecast:</strong> Phosphate Rock prices 32% P2O5; Contract price, F.A.S. Casablanca. Incentive price CAPEX and OPEX considerations for future long-term price levels.',
        ],
      },
    ],
    images: {
      one: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1694641637/assets/forecasts/phosphate/benchmarkminerals_Phosphoric_acid_tones_of_yellow_and_white_in__4b8e566b-eed9-4f73-9fa5-dc6b96c68b07_2_f8cjfn.png',
        alt: 'Synthetic Graphite Forecasts',
      },
      two: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1694641649/assets/forecasts/phosphate/benchmarkminerals_Phosphoric_acid_tones_of_yellow_and_white_in__4b8e566b-eed9-4f73-9fa5-dc6b96c68b07_2_1_pvjwv4.png',
        alt: 'Synthetic Graphite Forecasts',
      },
      three: {
        url: 'https://res.cloudinary.com/benchmarkminerals/image/upload/f_auto,q_auto,g_auto,w_auto/v1694641659/assets/forecasts/phosphate/benchmarkminerals_LFP_Battery_Cell_tones_of_yellow_and_white_in_c1499e8d-1e1e-4477-906e-2cfceac1b16d_2_eolfnp.png',
        alt: 'Synthetic Graphite Forecasts',
      },
    },
  },
  sections: {
    one: {
      image:
        'https://res.cloudinary.com/benchmarkminerals/image/upload/c_fill,q_auto,g_auto,h_700,f_auto/v1694641671/assets/forecasts/phosphate/benchmarkminerals_Data_on_a_10_large_screens_charts_graphs_visu_2d5af8f8-bac6-4270-afce-27aae5a96bfd_1_d2hpei.png',
      title:
        'Benchmark’s Phosphoric Acid Market Outlook service features detailed data and analysis out to 2030:',
      descriptions: [
        {
          subtitle: '',
          items: [
            '<strong>Market outlook:</strong> Compare phosphoric acid market outlooks by raw material and processed product for a thorough view of the market.',
            '<strong>Demand drivers:</strong> End-use demand broken down by specific end-use out to 2030.',
            '<strong>ESG insights:</strong> Explore the ESG metrics that need to be considered when evaluating future sources of phosphoric acid supply and demand.',
            '<strong>Regional perspectives:</strong> Examine processed phosphoric acid supply dynamics on a regional and asset basis.',
            '<strong>Developments:</strong> Track key investments, partnerships, and announcements over each quarter',
          ],
        },
      ],
    },
    two: {
      image:
        'https://res.cloudinary.com/benchmarkminerals/image/upload/c_fill,q_auto,g_auto,h_500,f_auto/v1694641681/assets/forecasts/phosphate/benchmarkminerals_Data_on_a_10_large_screens_45_degree_angle_ch_50187cc6-1672-4dc8-aacb-5c25afdd67cd_2_qobpd8.png',
      title:
        'You will receive full, unrestricted access to the data presented in Benchmark’s Phosphoric Acid Market Outlook service:',
      descriptions: [
        {
          items: [
            '<strong>Online accessible</strong> downloads each quarter',
            '<strong>Clear & Concise:</strong> Your data is presented in excel and pdf format.',
          ],
        },
      ],
    },
  },
}
export default phosphateData
